export var EnvVariables;
(function (EnvVariables) {
    EnvVariables["FILE_END_POINT"] = "FILE_END_POINT";
    EnvVariables["LOGIN_URL"] = "LOGIN_URL";
    EnvVariables["REALM"] = "REALM";
    EnvVariables["LOCALIZATION_URL"] = "LOCALIZATION_URL";
    EnvVariables["SIGNALR_URL"] = "SIGNALR_URL";
    EnvVariables["HUB_URL"] = "HUB_URL";
    EnvVariables["AXIOS_URL"] = "AXIOS_URL";
    EnvVariables["CHAT_URL"] = "CHAT_URL";
    EnvVariables["YM_ID"] = "YM_ID";
})(EnvVariables || (EnvVariables = {}));
